import isEmpty from "lodash/isEmpty";
import React from "react";
import LookupTableParameterEdit from "components/lookup-table-parameters/LookupTableParameterEdit";
import { Button, BootstrapModalForm } from "components/bootstrap";
class EditQueryParameterModal extends React.Component {
  constructor(props) {
    super(props);
    this.openModal = () => {
      const { queryParameter } = this.props;
      this.setState({ showModal: true, queryParameter });
    };
    this._cleanState = () => {
      const { queryParameter } = this.props;
      this.setState({ queryParameter, showModal: false });
    };
    this._saved = () => {
      const { queryParameter } = this.state;
      if (!this._validate(queryParameter)) {
        return;
      }
      this.propagateChanges();
      this._cleanState();
    };
    this.propagateChanges = () => {
      const { queryParameters, onChange, queryParameter: prevQueryParameter } = this.props;
      const { queryParameter } = this.state;
      const newQueryParameters = [...queryParameters];
      const index = queryParameters.findIndex((p) => p.name === prevQueryParameter.name);
      if (index < 0) {
        throw new Error(`Query parameter "${queryParameter.name}" not found`);
      }
      newQueryParameters[index] = queryParameter.toJSON();
      onChange(newQueryParameters);
    };
    this.handleParameterChange = (key, value) => {
      const { queryParameter } = this.state;
      const nextQueryParameter = queryParameter.toBuilder()[key](value).build();
      this.setState({ queryParameter: nextQueryParameter });
    };
    this._validate = (queryParameter) => {
      const newValidation = {};
      if (!queryParameter.lookupTable) {
        newValidation.lookupTable = "Cannot be empty";
      }
      if (!queryParameter.key) {
        newValidation.key = "Cannot be empty";
      }
      this.setState({ validation: newValidation });
      return isEmpty(newValidation);
    };
    const { queryParameter } = this.props;
    this.state = {
      showModal: false,
      queryParameter,
      validation: {}
    };
  }
  render() {
    const { lookupTables, embryonic } = this.props;
    const { queryParameter, validation, showModal } = this.state;
    const validationState = {
      lookupTable: validation.lookupTable ? ["error", validation.lookupTable] : void 0,
      key: validation.key ? ["error", validation.key] : void 0
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "small", bsStyle: embryonic ? "primary" : "info", onClick: () => this.openModal() }, queryParameter.name, embryonic && ": undeclared"), /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        show: showModal,
        title: `Declare Query Parameter "${queryParameter.name}" from Lookup Table`,
        "data-telemetry-title": "Declare Query Parameter from Lookup Table",
        onSubmitForm: this._saved,
        onCancel: this._cleanState,
        submitButtonText: "Save"
      },
      /* @__PURE__ */ React.createElement(
        LookupTableParameterEdit,
        {
          validationState,
          identifier: queryParameter.name,
          parameter: queryParameter,
          onChange: this.handleParameterChange,
          lookupTables
        }
      )
    ));
  }
}
export default EditQueryParameterModal;
